import { useState } from "react";
import { ELEMENT_META } from "@/data/breedingPals";

// Pal portrait with graceful fallback for pals without a hosted icon.
export function PalAvatar({ pal, size = 40, className = "", showElement = false }) {
  const [err, setErr] = useState(false);
  const px = { width: size, height: size };
  const ring =
    pal.rarity >= 10 ? "#FACC15" : pal.rarity >= 8 ? "#D946EF" : pal.rarity >= 5 ? "#3B82F6" : "hsl(var(--border))";
  return (
    <div className={`relative shrink-0 ${className}`} style={px}>
      {pal.img && !err ? (
        <img
          src={pal.img}
          alt={pal.name}
          onError={() => setErr(true)}
          loading="lazy"
          className="w-full h-full rounded-full object-cover bg-black/30"
          style={{ border: `2px solid ${ring}` }}
        />
      ) : (
        <div
          className="w-full h-full rounded-full flex items-center justify-center font-bold text-primary bg-primary/15"
          style={{ border: `2px solid ${ring}`, fontSize: size * 0.4 }}
        >
          {pal.name.charAt(0)}
        </div>
      )}
      {showElement && pal.elements?.[0] && (
        <span
          className="absolute -bottom-0.5 -right-0.5 w-3.5 h-3.5 rounded-full border border-black/50"
          style={{ background: ELEMENT_META[pal.elements[0]]?.color || "#94A3B8" }}
          title={ELEMENT_META[pal.elements[0]]?.label}
        />
      )}
    </div>
  );
}

export function ElementBadges({ elements = [] }) {
  return (
    <span className="inline-flex gap-1">
      {elements.map((e) => {
        const m = ELEMENT_META[e];
        if (!m) return null;
        return (
          <span
            key={e}
            className="inline-flex items-center rounded-full px-1.5 py-0.5 text-[9px] font-bold uppercase tracking-wide"
            style={{ color: m.color, background: `${m.color}1a`, border: `1px solid ${m.color}55` }}
          >
            {m.label}
          </span>
        );
      })}
    </span>
  );
}
